import { RsHTMLElement } from '../rs-htmlelement.js';

export class RsSortExpression extends RsHTMLElement {
    expression;
    label;

    mounted() {
        this.expression = this.getAttribute('expression');
        this.label = this.getAttribute('label');
    }
};